module.exports = __webpack_public_path__ + "static/about_v.3366228b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about_v.jpg
// module id = 1708
// module chunks = 162898551421021